import React from 'react';
import PropTypes, { bool } from 'prop-types';

import { NativeTypes } from 'react-dnd-html5-backend';
import { useDrop } from 'react-dnd';
import { connect } from 'react-redux';
import { BtnsWrapper, DropZoneWrapper, Image } from './style';
import Text from '../Text';
import CTA from '../CTA';
import { MODAL_OPEN } from '../../../app/redux/actions';
import DragAndDrop from '../../assets/img/drag&drop.png';
import { ModalInnerDocumentsId } from '../Modals/ModalInnerDocuments';

const DropZone = ({
  onDrop,
  onClick,
  validFormat = true,
  error,
  modalOpen,
  onlyFromPC,
}) => {
  const [{ canDrop, isOver }, drop] = useDrop({
    accept: [NativeTypes.FILE],
    drop(item, monitor) {
      if (onDrop) {
        onDrop(monitor);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });
  const isActive = canDrop && isOver;

  return (
    <DropZoneWrapper ref={drop}>
      <Image src={DragAndDrop} alt="" />
      {isActive ? (
        <Text type="h3">Trascina il file qui.</Text>
      ) : (
        <>
          <Text type="h3.5" mb={8}>
            Trascina il file per caricarlo
          </Text>
          <Text type="b4" mb={16}>
            oppure seleziona file da:
          </Text>
          <BtnsWrapper>
            {!onlyFromPC && (
              <CTA
                btnText="Archivio SISFOR"
                onClick={() => modalOpen(ModalInnerDocumentsId)}
              />
            )}
            <CTA btnText="Questo dispositivo" onClick={onClick} />
          </BtnsWrapper>
          {!validFormat ? (
            <Text type="b3" mt={16}>
              Formato non supportato.
            </Text>
          ) : (
            error && <Text type="b3">{error}</Text>
          )}
        </>
      )}
    </DropZoneWrapper>
  );
};

DropZone.propTypes = {
  onClick: PropTypes.func,
  validFormat: bool,
  onDrop: PropTypes.func,
  error: PropTypes.string,
  modalOpen: PropTypes.func,
  onlyFromPC: PropTypes.bool,
};

export default connect(
  (state) => {
    return {};
  },
  (dispatch) => ({
    modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
  })
)(DropZone);
